import React, {useState, useEffect, useCallback} from "react";
import {Form, Table, Button, InputGroup, FormControl} from "react-bootstrap";
import {useLocation, useHistory} from "react-router-dom";
import _ from 'lodash';
import {SearchProductDialog} from "../SearchProductDialog";
import {getProductById} from "../../../../redux/modules/products/crud";
import {prodName, price} from "../../../../utils/formatter";
import {CardBody, CardFooter} from "../../../../_metronic/_partials/controls";
import {postLink} from "../../../../redux/modules/links/crud";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function LinkForm() {
  const query = useQuery();
  const history = useHistory();
  const prodId = query.get('prodId');

  const [linkNm, setLinkNm] = useState('');
  const [products, setProducts] = useState([]);
  const [openSearchDlg, setOpenSearchDlg] = useState(false);

  const handleOpenSearchProduct = () => {
    setOpenSearchDlg(true);
  };

  const handleSelectItem = (product) => {
    setProducts([...products, product]);
  };

  const handleSetAmt = (e, index) => {
    const _products = [...products];
    const saleAmt = parseInt(e.target.value, 10);
    _products[index].saleAmt = _.isNaN(saleAmt) ? '' : saleAmt;
    setProducts(_products);
  };

  const handleSubmit = async () => {
    const goodsList = products.map(({goodsNo, saleAmt}) => ({goodsNo, saleAmt}));
    try {
      await postLink({linkNm, goodsList});
      alert('저장 되었습니다.');
      history.push('/services/links');
    } catch(error) {
      alert(error.message);
    }
  };

  const isInvalid = !linkNm.trim() || !products.length || !!products.find(
  prod => (
    !prod.saleAmt ||
    (prod.saleAmt && !_.isNumber(prod.saleAmt)) ||
    (prod.saleAmt && prod.saleAmt <= parseInt(prod.salePrc))
  ));

  const fetchProduct = useCallback(async (prodId) => {
    try {
      if (!prodId) return;

      const product = await getProductById(prodId);
      product.imgUrl = product.goodsImgList.find(img => img.reprYn === 'Y').imgUrl;
      product.splyId = product.regId;
      product.splyNm = product.regNm;
      product.optNm = product.saleOptList && product.saleOptList[0].optNm;
      setProducts([...products, product]);
    } catch (err) {
      alert(err.message);
    }
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (prodId) {
      fetchProduct(prodId);
    }
  // eslint-disable-next-line
  }, [prodId]);

  return (
    <>
      {/* Start:: LinkForm */}
      <CardBody className="mb-10">
        <Table className="mb-3" borderless>
          <colgroup>
            <col width="120px"/>
            <col width="auto"/>
          </colgroup>
          <tbody>
          <tr>
            <th>
              <span className="text-danger mr-3">*</span>
              링크명
            </th>
            <td>
              <Form.Control
                type="text"
                placeholder="링크명을 입력하세요."
                value={linkNm}
                onChange={e => setLinkNm(e.target.value)}
              />
              <Form.Text className="text-danger">
                * 등록한 링크명은 관리용으로 링크목록에 출력됩니다.
              </Form.Text>
            </td>
          </tr>
          <tr>
            <th>
              <span className="text-danger mr-3">*</span>
              판매 상품
            </th>
            <td>
              <Button
                className="w-120px"
                variant="success"
                size="sm"
                disabled={products.length}
                onClick={handleOpenSearchProduct}
              >
                <span className="font-weight-bolder">
                  상품 검색
                </span>
              </Button>
            </td>
          </tr>
          </tbody>
        </Table>
        <Table responsive variant="light-info" className="mt-5" bordered>
          <thead>
          <tr>
            <th></th>
            <th>NO</th>
            <th>상품코드</th>
            <th>카테고리</th>
            <th>상품명</th>
            <th>옵션</th>
            <th>정가</th>
            <th>공급가</th>
            <th className="bg-light-danger">
              <span className="text-danger mr-2">*</span>
              판매가
            </th>
            {/*<th>공급파트너</th>*/}
          </tr>
          </thead>

          <tbody>
          {products.map((prod, index) => (
            <tr key={`trow-${prod.goodsNo}`}>
              <td></td>
              <td>{index + 1}</td>
              <td>{prod.goodsNo}</td>
              <td>{prod.catNm1} > {prod.catNm2}</td>
              <td>{prodName(prod.goodsNm, prod)}</td>
              {/*<td>{OptionsFormatter(prod.goodsOptList)}</td>*/}
              <td style={{maxWidth: 300}} className="keep-all">
                {prod.optNm}
              </td>
              <td>{price(prod.normalPrc)}</td>
              <td>{price(prod.salePrc)}</td>
              <td className="bg-light-danger">
                <InputGroup className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>₩</InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    className="text-right"
                    isInvalid={
                      (prod.saleAmt && !_.isNumber(prod.saleAmt)) ||
                      (prod.saleAmt && prod.saleAmt <= parseInt(prod.salePrc))
                    }
                    value={prod.saleAmt}
                    onChange={e => handleSetAmt(e, index)}
                  />
                </InputGroup>
                {prod.saleAmt && prod.saleAmt <= parseInt(prod.salePrc) && (
                  <div className="text-danger">
                    공급가보다 높아야 합니다.
                  </div>
                )}
              </td>
            </tr>
          ))}
          {!products.length && (
            <tr>
              <td colSpan={10} className="text-center py-5">
                  <span className="text-muted">
                    선택된 상품이 없습니다.
                  </span>
              </td>
            </tr>
          )}
          </tbody>
        </Table>
      </CardBody>

      <CardFooter>
        <div className="text-right">
          <Button
            className="w-120px mr-3"
            variant="secondary"
            size="sm"
            onClick={() => history.goBack()}
          >
            <span className="font-weight-bolder">
              취소
            </span>
          </Button>

          <Button
            disabled={isInvalid}
            className="w-140px"
            variant="primary"
            size="sm"
            onClick={handleSubmit}
          >
            <span className="font-weight-bolder">
              링크 생성하기
            </span>
          </Button>
        </div>
      </CardFooter>

      {openSearchDlg && (
        <SearchProductDialog
          open={openSearchDlg}
          onHide={() => setOpenSearchDlg(false)}
          onSelect={handleSelectItem}
        />
      )}
    </>
  )
}
